import { connect } from 'react-redux';
import TimeZoneSwitchWidget from './TimeZoneSwitchWidget';
import { getSelectedTimezone } from '../../redux/selectors/timezone';
import { isEventAndDeviceTimeZoneOffSetSame } from '../../redux/modules/timezones';


/**
 * Data wrapper for the Time Zone Switch widget
 */
export default connect(
  (state, props) => {
    const translate = state.guestText ? state.guestText.translate : state.text.translate;
    const { classes, style, switchTimeZone, widgetName, instructionalTextStyles, hideAdjustTimeZone } = props;
    return {
      translate,
      classes,
      style,
      switchTimeZone,
      instructionalTextStyles,
      selectedTimeZone: getSelectedTimezone(state),
      eventTimeZone: state.timezones[state.event.timezone],
      hideAdjustTimeZone,
      isEventAndDeviceTimeZoneOffSetSame: isEventAndDeviceTimeZoneOffSetSame(state.event.startDate,
        state.timezones[state.event.timezone]),
      showTimeZoneWidget: state.appData.timeZoneSetting && state.appData.timeZoneSetting.selectedWidgets &&
                state.appData.timeZoneSetting.selectedWidgets.includes(widgetName)
    };
  }
)(TimeZoneSwitchWidget);
